import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NbDialogService } from '@nebular/theme';
import { ConfirmModalComponent } from '../../modals/confirm-modal.component';

import { MediaService } from '../../../_services/index';
import { Media } from '../../../classes';

import { Storage, ref, UploadTask, uploadString, percentage, uploadBytesResumable, TaskEvent, uploadBytes } from '@angular/fire/storage';

import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-media-lib',
    templateUrl: './media-lib.component.html',
    styleUrls: ['./media-lib.component.scss'],
    standalone: false
})

export class MediaLibComponent {

  @Input() gameId;
  @Input() templateId;

  medias = [];
  mediaSubscriber;

  loading;

  selectedMedia;
  selectedFile;
  
  task;
  progress;

  constructor(private route: ActivatedRoute,
    public mediaService: MediaService,
    private storage: Storage,
    private dialogService: NbDialogService) {
  }

  ngOnInit() {
    
    this.loading = true;
    if(this.mediaSubscriber){
      this.mediaSubscriber.unsubscribe();
    }
    this.mediaSubscriber = this.mediaService.listMedias(this.getStoragePath())
    .subscribe(medias => {
      //console.log('Found missions:'+JSON.stringify(missions));
      if(medias){
        this.medias = medias;
        this.loading = false;
      }
    });
  }

  select(media){
    this.selectedMedia = {...media};
  }

  async handleFileUpdated(file){
    console.log('Selected file:'+file);
    this.selectedFile = file;
    await this.uploadMedia();
  }

  getStoragePath(){
    if(this.gameId){
      return `games/${this.gameId}/medias`;
    }
    else{
      return `game_templates/${this.templateId}/medias`;
    }
  }

  async uploadMedia(){
    
    const filePath = this.getStoragePath();
    let mediaId = this.mediaService.createMediaRef(filePath).id;
    
    let fileName = `/${mediaId}`;

    let uploadRef = ref(this.storage, filePath+fileName);
    //let task:any = uploadString(uploadRef, this.selectedFile, 'data_url');
    let blob = await (await fetch(this.selectedFile)).blob();
    console.log('Blob:'+blob);
    let task:any = uploadBytesResumable(uploadRef, blob);
    
    task.then(async () => {
      const url = 'https://storage.googleapis.com/'+environment.firebase.storageBucket+'/'+filePath+fileName;
      console.log('file uploaded to:'+url);
      this.selectedMedia.fileURL = url;
      this.selectedMedia.filePath = filePath+fileName;
      this.selectedMedia.lastUpdate = new Date().getTime();
      this.saveMedia();
      setTimeout(() => {
        delete this.progress;
      }, 1000);
    });

    // Percentage observer
    percentage(task).subscribe((percentage) => {
      this.progress =  Math.round(percentage.progress);
    });
  }

  createMedia(){
    this.selectedMedia = new Media(this.getStoragePath());
    if(this.templateId){
      this.selectedMedia.templateId = this.templateId;
    }
    else if(this.gameId){
      this.selectedMedia.gameId = this.gameId;
    }
    this.selectedMedia.id = this.mediaService.createMediaRef(this.getStoragePath()).id;
  }

  saveMedia(){
    this.mediaService.setMedia(this.selectedMedia);
  }

  deleteMedia(){
    this.dialogService.open(ConfirmModalComponent, { 
      context: {
        title: 'Confirmation',
        message: `Are you sure you want to delete this media?`
      }, closeOnBackdropClick: false
    })
    .onClose.subscribe(async res => {
      console.log('Dialog returns:'+res);
      if(res){
        this.mediaService.deleteMedia(this.selectedMedia);
        delete this.selectedMedia;
      }
    });
  }

  ngOnDestroy(){
    if(this.mediaSubscriber){
      this.mediaSubscriber.unsubscribe();
    }
  }
}
